/**
 * Sticky cart limit bar – counts only sample products, updates when cart changes
 * Sample = line item property _is_sample (Yes / true) set when adding sample to cart
 */
(function () {
  function isSampleItem(item) {
    if (!item) return false;
    var props = item.properties || {};
    return props._is_sample == true || props._is_sample == 'true';
  }

  function countSampleQuantityFromCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + (isSampleItem(item) ? (item.quantity || 0) : 0);
    }, 0);
  }

  function getBar() {
    return document.querySelector('[id^="sticky-cart-limit-bar-"]');
  }

  function isSampleLimitBar(bar) {
    return bar && bar.dataset.limitContext === 'sample';
  }

  function updateBar(bar, sampleCount, maxLimit) {
    if (!bar || !isSampleLimitBar(bar)) return;
    var maxEl = bar.querySelector('[data-cart-limit-max]');
    var currentEl = bar.querySelector('[data-cart-limit-current]');
    var remainingEl = bar.querySelector('[data-cart-limit-remaining-text]');
    var limit = maxLimit != null ? maxLimit : (parseInt(bar.dataset.maxLimit, 10) || 20);
    var remaining = Math.max(0, limit - sampleCount);

    bar.dataset.cartCurrent = String(sampleCount);
    bar.dataset.cartRemaining = String(remaining);

    if (maxEl) maxEl.textContent = limit;
    if (currentEl) currentEl.textContent = sampleCount;
    if (remainingEl) remainingEl.textContent = remainingEl.textContent.replace(/\d+/, remaining);
  }

  function applyCartToBar(bar, cart) {
    if (!bar || !cart || !isSampleLimitBar(bar)) return;
    var maxLimit = parseInt(bar.dataset.maxLimit, 10) || 20;
    var sampleCount = countSampleQuantityFromCart(cart);
    updateBar(bar, sampleCount, maxLimit);
  }

  function refreshFromCart(bar) {
    if (!bar) return;
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        applyCartToBar(bar, cart);
      })
      .catch(function () {});
  }

  function onCartUpdate(event) {
    var bar = getBar();
    if (!bar || !isSampleLimitBar(bar)) return;
    if (event && event.cartData) {
      applyCartToBar(bar, event.cartData);
      return;
    }
    refreshFromCart(bar);
  }

  function init() {
    var bar = getBar();
    if (!bar || !isSampleLimitBar(bar)) return;

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }

    document.addEventListener('cart:updated', function (event) {
      var bar = getBar();
      if (!bar || !isSampleLimitBar(bar)) return;
      if (event.detail && event.detail.cart) {
        applyCartToBar(bar, event.detail.cart);
        return;
      }
      refreshFromCart(bar);
    });

    refreshFromCart(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
